export function joinAndMap(array, map, separator = ', ') {
    if (!array.length)
        return '';

    return array.map(item => map(item)).join(separator);
}
